import { createPluginFactory, HotkeyPlugin } from '@udecode/plate';

export const ELEMENT_AI_CONTENT = 'ai_content';

export const createAiContentPlugin = createPluginFactory<HotkeyPlugin>({
  key: ELEMENT_AI_CONTENT,
  isElement: true,
});
